<template>
  <div class="col-xs-12 p-20">
    <div
      class="heading separator d-flex align-items-center xs-flex-start pr-8 mb-15 xs-flex-column justify-space-between"
    >
      <div class="d-flex col-gap-15 align-items-center flex-70">
        <img
          class="cursor-pointer"
          src="static/images/icons/chevron_left.svg"
          @click="$router.go(-1)"
        />
        <span class="word-break text-emergo-dark-blue"
          >{{ searchResponse.total_search_result_count }} Result(s) for ‘{{ searchTerm }}’ in
          {{ serviceName }}
        </span>
      </div>
      <button @click="$router.go(-1)" class="emergo-white-button xs-flex-100">Exit Search</button>
    </div>
    <div class="col-lg-12 p-0">
      <div class="col-xs-12 p-0 position-relative filter-wrapper">
        <shared-left-filter
          @setFilter="filteredOptions"
          :chevronList="chevronList"
          :expectedFilter="resultingFilter"
          :categoriesList="categoriesList"
          :countriesList="countryListFilter"
          :types="types"
          :isCountryString="true"
        >
        </shared-left-filter>
      </div>
      <div class="col-xs-12 p-0 list-wrapper">
        <template v-if="subCategoryResults[0]">
          <div
            class="col-xs-12 p-0"
            v-for="(service, index) in subCategoryResults[0].service_results"
            :key="index + 0"
          >
            <div class="card cursor-pointer" @click="navigateToRespectivePage(service)">
              <services :serviceName="serviceName" :recordInfo="service"></services>
            </div>
          </div>
        </template>
      </div>
    </div>
    <div class="pagination-wrapper col-xs-12 p-0">
      <pagination
        v-if="total"
        :totalPages="totalPages"
        :maxVisibleButtons="maxVisiblePages"
        :total="total"
        :perPage="perPage"
        :currentPage="currentPage"
        @pagechanged="pagechanged"
      ></pagination>
    </div>
    <unsubscribed-country-popup
      id="modal_unsubscribed_market"
      :isGlobalSearch="true"
      :selectedServiceId="selectedServiceId"
    ></unsubscribed-country-popup>
    <loader :loadingStatus="loaderStatus"></loader>
  </div>
</template>
<script>
import Loader from '../../UIComponents/Loader.vue';
import UnsubscribedCountryPopup from '../../RegulatoryProcessCharts/UnsubscribedCountryPopup.vue';
import SharedLeftFilter from '../../UIComponents/SharedLeftFilter.vue';
import globalSearch from '../../../apis/globalSearch';
import Pagination from '../../UIComponents/Pagination.vue';
import Services from './Services.vue';
import { GLOBAL_SEARCH_CATEGORIES, GLOBALSEARCH_MAPPING } from './constants';
import globalSearchMixin from './mixins';

export default {
  mixins: [globalSearchMixin],
  data() {
    return {
      searchCategories: GLOBAL_SEARCH_CATEGORIES,
      loaderStatus: false,
      searchResponse: {},
      filterOptions: {},
      chevronList: {
        isCountryChevron: 'Country'
      },
      types: {
        countryId: 'name',
        countryName: 'name'
      },
      resultingFilter: {
        countriesList: [],
        isFilterSelected: false
      },
      commonLists: {
        date: false,
        country: true,
        categoryList: false
      },
      categoriesList: [],
      searchTerm: '',
      subCategoryResults: [],
      fromRecords: '',
      totalPages: 0,
      total: 0,
      maxVisiblePages: 4,
      perPage: 15,
      currentPage: 1,
      countryListFilter: [],
      serviceName: '',
      selectedServiceId: null,
      servicesWithIdAsIdentifier: {},
      activeServicesWithIdAsIdentifier: {}
    };
  },
  components: { SharedLeftFilter, Pagination, Loader, Services, UnsubscribedCountryPopup },
  methods: {
    /**
     * this will set the filter options from the left filter and then fetches the list
     * @param {object} filter
     */
    async filteredOptions(filter) {
      this.filterOptions = JSON.parse(JSON.stringify(filter));
      this.currentPage = 1;
      this.pagechanged(1);
    },

    navigateToRespectivePage(service) {
      const serviceName = GLOBALSEARCH_MAPPING[this.serviceName];
      this.selectedServiceId = this.servicesWithIdAsIdentifier[serviceName];
      this.navigateIfServiceHasAccess(serviceName, this.serviceName, service);
    },
    async pagechanged(currentPage) {
      this.loaderStatus = true;
      if (currentPage) this.currentPage = currentPage;
      await this.getResultsList();
      this.subCategoryResults = this.searchResponse.results;
      this.setPaginationLimits();
      this.loaderStatus = false;
    },

    setPaginationLimits() {
      this.total = this.searchResponse.total_search_result_count;
      this.totalPages = Math.ceil(this.total / this.perPage);
    },
    async getResultsList(allCountries = false) {
      const request = {
        page_size: this.perPage,
        paze_number: this.currentPage - 1,
        search_value: this.searchTerm,
        services: [this.serviceName]
      };
      if (!allCountries) request.countries = this.filterOptions.countriesList;
      this.searchResponse = await globalSearch(request);
      this.subCategoryResults = this.searchResponse.results;
      if (allCountries) this.setCountriesList(this.subCategoryResults[0].subscribed_countries);
    },
    setCountriesList(countriesList) {
      this.countryListFilter = countriesList;
    }
  },
  /**
   * setServices is a part of global search mixin which is used in couple of components
   */
  async created() {
    const { service, searchTerm } = this.$route.query;
    this.searchTerm = searchTerm;
    this.serviceName = service;
    if (!service || !searchTerm) this.$router.push('/layout/dashboard');
    this.loaderStatus = true;
    await this.setServices();
    await this.getResultsList(true);
    this.setPaginationLimits();
    this.loaderStatus = false;
  }
};
</script>
<style scoped>
.heading.separator {
  padding-bottom: 22px;
  border-bottom: 0.7px solid #bdbdbd;
}

.emergo-white-button {
  padding: 7px 26px;
}

.heading span {
  font-weight: 400;
  font-size: 24px;
  line-height: 28px;
}
.card {
  background: #ffffff;
  box-shadow: 0px 2px 7px rgb(0 0 0 / 25%);
  border-radius: 10px;
  padding: 24px 32px;
  margin-bottom: 16px;
  box-shadow: 0px 1px 12px rgba(0, 0, 0, 0.27);
}

.list-wrapper {
  padding: 0px 80px 60px 80px;
}

.flex-70 {
  flex-basis: 70%;
}

.filter-wrapper {
  top: -18px;
  left: -16px;
}

.pagination-wrapper {
  position: fixed;
  bottom: 0px;
  left: 230px;
  width: calc(100% - 230px);
  background: #ffffff;
  border-top: 0.7px solid #bdbdbd;
  z-index: 3;
}

@media screen and (max-width: 1300px) {
  .pagination-wrapper {
    width: 100%;
    left: 0px;
  }
}

@media screen and (max-width: 767px) {
  .xs-flex-column {
    flex-direction: column;
    row-gap: 20px;
  }

  .list-wrapper {
    padding: 0px;
  }

  .xs-flex-100 {
    width: 100%;
  }

  .xs-flex-start {
    align-items: flex-start;
  }
}
</style>
